import Validator from 'services/data-validator'

const confirmationCodeValidator = values => {
  const rules = {
    code: [
      'isRequired',
      ['minLength', { count: 4 }]
    ]
  }

  return new Validator(values, rules).getErrors()
}

export default confirmationCodeValidator
